export default "__VITE_ASSET__DXEAyE01__"